import {Stack} from '../../layout/stack/stack';
import {LoadingPage} from '../../loading-page/loading-page';

import {MatrixHeatmapColumnHeaders} from './matrix-heatmap-column-headers';
import {MatrixHeatmapHeader} from './matrix-heatmap-header';
import {MatrixHeatmapRow} from './matrix-heatmap-row';
import type {MatrixHeatmapRowData} from './types';

interface Props {
    header: string;
    subheader?: string;
    keyName: string;
    rows: MatrixHeatmapRowData[];
    columnAxisLabel: string;
    rowPrimaryHeaderLabel: string;
    rowMetricHeaderLabel?: string;
    isLoading: boolean;
    /** When loading, use this to size the loading container (rows × (40px + 4px)) */
    expectedRowCount?: number;
}

export function MatrixHeatmap(props: Props) {
    const numColumns = props.rows[0]?.cells.length ?? 0;
    const hasMetric = props.rows.some((row) => Boolean(row.metricText));

    return (
        <Stack spacing={24}>
            <MatrixHeatmapHeader
                header={props.header}
                subheader={props.subheader}
                keyName={props.keyName}
            />
            <Stack spacing={8}>
                {props.isLoading ? (
                    <div
                        className='full-width'
                        style={
                            props.expectedRowCount != null
                                ? {height: props.expectedRowCount * 44 + 46}
                                : undefined
                        }
                    >
                        <LoadingPage size={48} padding={48} />
                    </div>
                ) : (
                    <>
                        <MatrixHeatmapColumnHeaders
                            columnAxisLabel={props.columnAxisLabel}
                            rowPrimaryHeaderLabel={props.rowPrimaryHeaderLabel}
                            rowMetricHeaderLabel={props.rowMetricHeaderLabel}
                            numColumns={numColumns}
                            hasMetric={hasMetric}
                        />
                        <Stack spacing={4}>
                            {props.rows.map((row) => (
                                <MatrixHeatmapRow key={row.id} row={row} hasMetric={hasMetric} />
                            ))}
                        </Stack>
                    </>
                )}
            </Stack>
        </Stack>
    );
}
